import { Autocomplete, Button, InputAdornment, TextField } from "@mui/material";
import { Box, Grid } from "@mui/system";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import ConfigsFilterItems, { FilterOption } from "./ConfigsFilterItems";

interface Props {
  /** distinct configuration names, deduped by the owning tab */
  searchOptions: string[];
  selectedName: string | null;
  onSelectName: (value: string | null) => void;
  interfaceOptions: FilterOption[];
  selectedInterfaces: string[];
  onSelectedInterfacesChange: (value: string[]) => void;
  reportOptions: FilterOption[];
  selectedReports: string[];
  onSelectedReportsChange: (value: string[]) => void;
  onClearFilters: () => void;
  canCreate: boolean;
  onCreate: () => void;
}

/** Search box, filter buttons and the create action above the Configs table. */
const ConfigsFilterCard = ({
  searchOptions,
  selectedName,
  onSelectName,
  canCreate,
  onCreate,
  ...filterItemProps
}: Props) => (
  <Box sx={{ padding: "16px 16px 8px" }}>
    <Grid container rowSpacing={2} columnSpacing={3} alignItems="center">
      <Grid size={3}>
        <Autocomplete
          data-tracker="1095"
          sx={{ width: "100%" }}
          options={searchOptions}
          value={selectedName}
          onChange={(_, newValue) => onSelectName(newValue)}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Configuration Name"
              InputProps={{
                ...params.InputProps,
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon sx={{ marginLeft: "12px" }} />
                  </InputAdornment>
                ),
              }}
              color="secondary"
            />
          )}
          size="small"
        />
      </Grid>
      <Grid size={6}>
        <ConfigsFilterItems {...filterItemProps} />
      </Grid>
      <Grid size={3}>
        <Box display="flex" justifyContent="flex-end">
          {canCreate && (
            <Button
              variant="contained"
              color="secondary"
              sx={{ whiteSpace: "nowrap" }}
              onClick={onCreate}
              disabled
            >
              Create new Config <AddIcon sx={{ width: "20px", ml: "5px" }} />
            </Button>
          )}
        </Box>
      </Grid>
    </Grid>
  </Box>
);

export default ConfigsFilterCard;
